// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2tEs7","content":"Consent_content__EWlv9","footer":"Consent_footer__1C3d4"};